import React, { useState, useEffect, useRef } from 'react';
import {
  Grid,
  Button,
  Box,
  List,
  ListItem,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Typography,
  FormHelperText,
} from '@material-ui/core';
import styles from '../../../../styles/loadboard.module.scss';
import { Close } from '@material-ui/icons';
import { useDropzone } from 'react-dropzone';
import CmtProgressBar from '@coremat/CmtProgressBar';
import { useDispatch } from 'react-redux';
import { bulkUpload } from 'redux/actions/Loads';

export default function UploadDedicatedLoadsDialog(props) {
  useEffect(() => {}, [props.open]);
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    accept: '.csv',
    multiple: false,
  });

  const { handleLoadType } = props;
  const dispatch = useDispatch();
  const [csvArray, setCsvArray] = useState([]);
  const [errors, setErrors] = useState([]);
  const [finalArray, setFinalArray] = useState([]);
  const [progress, setProgress] = useState(0);
  const [files, setFiles] = useState(null);
  const [status, setStatus] = useState('Processing Csv Data...');
  const [index, setIndex] = useState(0);

  const processCSV = (str, delim = ',') => {
    const headers = str.slice(0, str.indexOf('\n')).split(delim);
    const rows = str.slice(str.indexOf('\n') + 1).split('\n');

    const newArray = rows.map((row, index) => {
      const values = row.split(delim);
      if (values.length == headers.length) {
        const eachObject = headers.reduce((obj, header, i) => {
          obj[header] = values[i];
          return obj;
        }, {});
        return eachObject;
      } else {
        handleErrors(0, index);
        return {};
      }
    });
    setCsvArray(newArray);
  };

  function handleUpload() {
    const reader = new FileReader();
    reader.onload = function(e) {
      const text = e.target.result;
      processCSV(text);
    };

    reader.readAsText(acceptedFiles[0]);
  }

  function handleErrors(start, index) {
    let newError = errors;
    newError.push(start + index + 2);
    setErrors(newError);
    return;
  }

  function getDataToSend(start, slicedArray) {
    let dataToSend = [];
    slicedArray.map((row, index) => {
      try {
        if (row && !row.Pickup_dates && !row.pick_up_date && !row.day_ran && !row.Day_Ran) {
          handleErrors(start, index);
        } else {
          let obj = {
            unique_load_id: row.unique_load_id || row.Load_Number,
            type: row.type || 'Dedicated',
            full_trailer_types: row.Equipment,
            trip_distance: row.Trip_Distance || row.trip_distance,
            weight: row.Weight || row.weight,
            length: row.Length || row.length,
            rate: row.Rate || row.rate,
            pick_up_date: row.Pickup_dates || row.pick_up_date,
            pick_up_time_start: row['P/U_Time'],
            delivery_date_time: row.delivery_date_time || `${row['Drop_Off_Date']} ${row['D/O_Time']}`,
            full_partial: row['Full/Partial'],
            driver_type: row.Driver_Type,
            comments: row.Comments || row.comments,
            source: row.Shipper,
            origin_state: row.Origin_State || row.origin_state,
            origin_city: row.Origin_City || row.origin_city,
            destination_state: row.Destination_State || row.destination_state,
            destination_city: row.Destination_City || row.destination_city,
            company_phone: row.Cell,
            commodity: row.Commodity || row.commodity,
            day_ran: row.day_ran || row.Day_Ran,
            no_of_trucks_required: row.no_of_trucks_required || row.No_of_Trucks_Required,
          };
          dataToSend.push(obj);
        }
      } catch (err) {
        handleErrors(start, index);
      }
    });
    return dataToSend;
  }

  function handleClose() {
    setCsvArray([]);
    setFinalArray([]);
    setProgress(0);
    setErrors([]);
    setStatus('Processing Csv Data...');
    setFiles(null);
    setIndex(1);
    props.handleUploadDialogClose();
  }

  useEffect(() => {
    if (csvArray && csvArray.length) {
      let start = 0;
      let limit = 40;
      let dataToSend = [];
      while (start <= csvArray.length) {
        let result = getDataToSend(start, csvArray.slice(start, start + limit));
        dataToSend.push(result);
        if (start + limit <= csvArray.length) {
          start = start + limit;
        } else {
          start = csvArray.length + 1;
        }
        setProgress(start);
      }
      setFinalArray(dataToSend);
    }
  }, [csvArray]);

  useEffect(() => {
    if (acceptedFiles.length) {
      handleUpload();
      let files = acceptedFiles.map(file => <span key={file.path}>{file.path}</span>);
      setFiles(files);
      setErrors([]);
    }
  }, [acceptedFiles]);

  useEffect(() => {
    if (finalArray.length && !errors.length) {
      let i = 0;
      setStatus('Uploading...');
      finalArray.map(v => {
        dispatch(bulkUpload({ loads: v }))
          .then(res => {
            i = i + 1;
            setIndex(i);
          })
          .catch();
      });
    }
  }, [finalArray]);

  useEffect(() => {
    if (finalArray.length && finalArray.length === index) {
      setStatus('File Uploaded Successfully');
      setTimeout(() => {
        handleClose();
        handleLoadType('Dedicated');
      }, [2000]);
    }
  }, [index]);

  return (
    <Dialog onClose={handleClose} open={props.open} className={styles.uploadDedicatedLoadsDialog}>
      <DialogTitle className={styles.dialogTitle}>
        Upload Dedicated loads
        <Close className={styles.closeIcon} onClick={handleClose} />
      </DialogTitle>
      <DialogContent className={styles.dialogContent}>
        <p>
          Please{' '}
          <a
            download="https://tb-email-assets.s3.us-west-1.amazonaws.com/sample_dedicated_loads.csv"
            href="https://tb-email-assets.s3.us-west-1.amazonaws.com/sample_dedicated_loads.csv">
            click here
          </a>{' '}
          to download the sample csv
        </p>

        <Box className={styles.uploadBlk}>
          <Box {...getRootProps({ className: 'dropzone' })}>
            <input {...getInputProps()} disabled={status === 'Uploading'} />
            {files && files.length ? (
              <Typography style={{ marginTop: '18px' }}>{files}</Typography>
            ) : (
              <Box className="textCenter">
                <Typography>Drag 'n' drop your file here, or click to select file</Typography>
                <Typography style={{ color: '#666666' }}>(Note: Only single .csv file is accepted) </Typography>
              </Box>
            )}
          </Box>
          {csvArray.length && progress ? (
            <Box mt={6} className={styles.progressBar}>
              <CmtProgressBar
                onlyContained={false}
                thickness={12}
                pointer={false}
                label={status}
                labelPos="bottom-center"
                hideValue={true}
                // valuePos="right"
                value={progress}
                total={csvArray.length + 1}
                // renderValue={(value, total) => {
                //   return (value + '/' + total);
                // }}
                emptyColor={'#e9ecef'}
                containedColor="#58b158"
              />
            </Box>
          ) : null}
          {errors && errors.length != 0 && <p className={styles.error}>{`Error in Rows ${errors.map(v => v).join(',')}`}</p>}
        </Box>
      </DialogContent>
      {/* <DialogActions className={styles.dialogActions}>
        <Box className={styles.showLoadsBtn + ' textRight'}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            style={{
              textTransform: 'capitalize',
              pointerEvents: `${status === 'File Uploaded Successfully' ? 'auto' : 'none'}`,
              opacity: `${status === 'File Uploaded Successfully' ? '1' : '0.6'}`,
            }}
            onClick={() => {
              props.handleUploadDialogClose();
              handleLoadType('Dedicated');
            }}>
            Continue
          </Button>
        </Box>
      </DialogActions> */}
    </Dialog>
  );
}
